import React, { useReducer, useState } from "react";
import { HStack } from "native-base";
import {
  KeyboardAvoidingView,
  ScrollView,
  StyleSheet,
  View,
} from "react-native";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";

import { USER_ID } from "../../../assets/consts";
import { faBuilding } from "../../../assets/consts/faCharCodes";
import { ArButton } from "../../argon-ui";
import Theme from "../../argon-ui/Theme";
import Text from "../../components_v2/TextFont";
import { translate } from "../../locales/translate";
import InputBase from "../../nativeBase-ui/InputBase";
// import PopoverBase from "../../nativeBase-ui/PopoverBase";
import * as SecureStore from "../../components_v2/DeviceAsyncStorage";
import { getDir, persianToEnglishNumber } from "../../util";
import * as AppActions from "../../actions/AppActions";
import RegisterBuildingInput from "../../components_v2/RegisterBuildingInput";

type Props = {
  navigation: any;
};
// === Validations ====
type FormValidityState = {
  buildingNameError: boolean;
  buildingNameErrorMessage: string;
  codeLetterError: boolean;
  codeLetterErrorMessage: string;
  codeDigiError: boolean;
  codeDigiErrorMessage: string;
  isFormValid: boolean;
};
const initialValidityState: FormValidityState = {
  buildingNameError: false,
  buildingNameErrorMessage: "",
  codeLetterError: false,
  codeLetterErrorMessage: "",
  codeDigiError: false,
  codeDigiErrorMessage: "",
  isFormValid: false,
};
type FormValidityAction = {
  type: string;
  payLoad: string;
};
const formValidityReducer = (
  state: FormValidityState,
  action: FormValidityAction
): FormValidityState => {
  let isValid: boolean = false;
  let IsRequired: string = "";
  switch (action.type) {
    case "VALIDATE_BUILDING_NAME":
      isValid = action.payLoad.length > 3 ? true : false;
      IsRequired =
        action.payLoad.length == 0
          ? translate("building.registerBuildingFormError.emptyBuildingName")
          : !isValid
          ? translate("building.registerBuildingFormError.InvalidBuildingName")
          : "";
      return {
        ...state,
        ...{
          buildingNameError: !isValid,
          isFormValid:
            (isValid || IsRequired == "") &&
            !state.codeLetterError &&
            !state.codeDigiError,
          buildingNameErrorMessage: IsRequired,
        },
      };
    case "VALIDATE_CODE_LETTER":
      isValid = action.payLoad.length == 3 ? true : false;
      IsRequired =
        action.payLoad.length == 0
          ? translate("building.registerBuildingFormError.requiredCodeLetter")
          : !isValid
          ? translate("building.registerBuildingFormError.lengthCodeLetter")
          : "";
      return {
        ...state,
        ...{
          codeLetterError: !isValid,
          isFormValid:
            (isValid || IsRequired == "") &&
            !state.buildingNameError &&
            !state.codeDigiError,
          codeLetterErrorMessage: IsRequired,
        },
      };
    case "VALIDATE_CODE_DIGI":
      isValid = action.payLoad.length == 4 ? true : false;
      IsRequired =
        action.payLoad.length == 0
          ? translate("building.registerBuildingFormError.requiredCodeDigi")
          : !isValid
          ? translate("building.registerBuildingFormError.lengthCodeDigi")
          : "";
      return {
        ...state,
        ...{
          codeDigiError: !isValid,
          isFormValid:
            (isValid || IsRequired == "") &&
            !state.buildingNameError &&
            !state.codeLetterError,
          codeDigiErrorMessage: IsRequired,
        },
      };
    default:
      return state;
  }
};

const AddBuildingScreen = (props: Props) => {
  const [buildingName, setBuildingName] = useState<string>("");
  const [codeLetter, steCodeLetter] = useState<string>("");
  const [codeDigi, setCodeDigi] = useState<string>("");

  const [loading, setLoading] = useState<boolean>(false);

  // === validation ===
  const [formValidityData, setFormValidityData] = useReducer(
    formValidityReducer,
    initialValidityState
  );
  // === Redux
  const appReducer = useSelector((state: any) => state.AppReducer);
  const dispatch = useDispatch();

  // === Register fetch handler ===
  const postRegisterBuilding = async (code: string) => {
    const { currentServer, serverUrl } = appReducer;
    var _serverUrl: string = serverUrl;
    const userId = await SecureStore.getItemAsync(USER_ID);
    if (!_serverUrl.endsWith("/")) {
      _serverUrl += "/";
    }
    if (_serverUrl && userId && currentServer.accessToken) {
      const headersJson = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${currentServer.accessToken}`,
      };
      const body = {
        userId,
        buildingName,
        code,
      };
      axios
        .post(`${_serverUrl}Buildings/Create`, body, {
          headers: headersJson,
        })
        .then((res) => {
          const { result, errors, model } = res.data;
          setLoading(false);
          if (result && Object.keys(model).length > 0) {
            // === render message toast ===
            const successMessage = {
              title: translate("building.message.successCreate", {
                buildingName: model.buildingName,
              }),
              variant: "top-accent",
              status: "success",
            };
            dispatch(AppActions.messageToast(successMessage));
            // === clear inputs ===
            setBuildingName("");
            setCodeDigi("");
            steCodeLetter("");
            // === change building ===
            setTimeout(() => {
              props.navigation.goBack();
              // === callBack ==
              props.navigation.state.params?.changeBuilding(model?.buildingId);
            }, 3000);
          } else {
            errors.map((error: string) => {
              const errorMessage = {
                title: translate(`building.message.errorMessage.${error}`),
                variant: "top-accent",
                status: "error",
              };
              dispatch(AppActions.messageToast(errorMessage));
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log("login error", error);
          const errorMessage = {
            title: translate(`login.errors.undefinedError`),
            variant: "top-accent",
            status: "error",
          };
          dispatch(AppActions.messageToast(errorMessage));
        });
    }
    loading &&
      setTimeout(() => {
        setLoading(false);
      }, 5000);
  };
  const submitHandler = () => {
    setFormValidityData({
      type: "VALIDATE_BUILDING_NAME",
      payLoad: buildingName,
    });
    setFormValidityData({
      type: "VALIDATE_CODE_DIGI",
      payLoad: codeDigi,
    });
    setFormValidityData({
      type: "VALIDATE_CODE_LETTER",
      payLoad: codeLetter,
    });
    if (formValidityData.isFormValid) {
      setLoading(true);
      // === Sum of codes (prefix + letter + digi) ===
      var code: string = codeLetter.toLocaleUpperCase() + codeDigi;
      code = code.replace(/\s+/g, "");
      // === convert persian number to english number ===
      code = persianToEnglishNumber(code);
      postRegisterBuilding(code);
    }
  };
  return (
    <KeyboardAvoidingView
      behavior="height"
      style={{ flex: 1 }}
      enabled={true}
      keyboardVerticalOffset={80}
    >
      <ScrollView style={style.container}>
        <View
          style={{ justifyContent: "center", minHeight: 40, marginVertical: 8 }}
        >
          <Text
            style={{
              color: Theme.COLORS.BLACK,
              fontSize: 18,
              textAlign: "center",
            }}
          >
            {translate("building.building") + " " + buildingName}
          </Text>
        </View>

        {/* === Building Name === */}
        <InputBase
          placeholder=""
          isInvalid={formValidityData.buildingNameError}
          errorMessage={formValidityData.buildingNameErrorMessage}
          showSubInput
          label={translate("building.buildingName")}
          onChangeText={(txt: string) => setBuildingName(txt)}
          onBlur={() =>
            setFormValidityData({
              type: "VALIDATE_BUILDING_NAME",
              payLoad: buildingName,
            })
          }
          value={buildingName}
          icon={faBuilding}
        />
        {/* === Register code === */}
        <RegisterBuildingInput
          codeLetter={codeLetter}
          steCodeLetter={steCodeLetter}
          codeDigi={codeDigi}
          setCodeDigi={setCodeDigi}
          formValidityData={formValidityData}
          setFormValidityData={(action: FormValidityAction) =>
            setFormValidityData(action)
          }
          callbackRegister={() => {
            if (buildingName !== "" && buildingName.length > 3) {
              submitHandler();
            }
          }}
        />
      </ScrollView>
      {/* === submit btn === */}
      <HStack space={2} style={{ padding: 10 }}>
        <ArButton
          isLoading={loading}
          color="primary"
          onPress={() => submitHandler()}
          style={{ flex: 1, marginBottom: 0 }}
        >
          {translate("app.save")}
        </ArButton>
        <ArButton
          color="muted"
          variant="outline"
          onPress={() => props.navigation.goBack()}
          style={{ flex: 1, marginBottom: 0 }}
        >
          {translate("app.goBack")}
        </ArButton>
      </HStack>
    </KeyboardAvoidingView>
  );
};

AddBuildingScreen["navigationOptions"] = ({
  screenProps: { translate },
}: any) => ({
  headerTitle: translate("navigation.addBuilding"),
});

export default AddBuildingScreen;

const style = StyleSheet.create({
  container: {
    paddingTop: 20,
    paddingHorizontal: 10,
  },
  codePrefixContainer: {
    justifyContent: "center",
    alignItems: "center",
    height: 45,
    borderRadius: 5,
    padding: 10,
    backgroundColor: Theme.COLORS.BORDER_COLOR,
  },
});
